import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects, Collections} from "components";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Tickets',
	url: '/tickets',
	icon: 'ticket',
}];

export default class Schedule extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			customer_name: '',
			customer_address: '',
			field_engineer: '',
			saveTicket: false,
			filterEngineer: null,
			mapsUrls: [],
			filterDate: new Date().getDate(),
			tab: 'calendar',
			calendarReload: false,
		};
	}

	updateSchedule = (updatedInfo) => {
		this.setState({scheduleInfo: updatedInfo})
	}

	updateFilter = (filterEngineer) => {
		this.setState({filterEngineer});
	}

	updateTime = (getFilterDate) => {
		this.setState({getFilterDate : new Date(getFilterDate)});
	}

	reloadCalendar = () => {
		this.setState({calendarReload: !this.state.calendarReload})
	}

	render() {
		let {match, history} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: match.params.id,
				url: `/tickets/${match.params.id}`,
				icon: 'ticket',
			},
			{
				name: 'Schedule',
				url: `/tickets/${match.params.id}/schedule`,
				icon: 'calendar',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Map" value={'map'}/>
					<Tab label="Calendar" value={'calendar'}/>
				</Tabs>

				<Card>
					<CardContent>
						<div className={'row'}>
							<div className={'col-4'}>
								<Objects.ScheduleTicket
									id={match.params.id}
									scheduleInfo={this.state.scheduleInfo}
									history={this.props.history}
									reloadShell={this.props.reloadShell}
									reloadPage={this.refreshPage}
									reloadSelf={this.state.refresh}
									updateName={this.updateName}
									baseUrl={this.props.baseUrl}
									saveSelf={this.state.saveTicket}
									// updateFilter={this.updateFilter}
									// updateTime={this.updateTime}
									// provideLocation={(customer_name, customer_address, field_engineer) => {
									// 	this.setState({
									// 		customer_name: customer_name,
									// 		customer_address: customer_address,
									// 		field_engineer: field_engineer
									// 	});
									// }}
									mapsUrls={this.state.mapsUrls}
									reloadCalendar={this.reloadCalendar}
								/>
							</div>
							<div className={'col-8'}>
								<div className={classNames({'hidden': this.state.tab !== 'map'})}>
									<Objects.ScheduleMap

										history={this.props.history}
										reloadShell={this.props.reloadShell}
										reloadPage={this.refreshPage}
										reloadSelf={this.state.refresh}
										updateName={this.updateName}
										baseUrl={this.props.baseUrl}

										customer_address={this.state.customer_address}
										customer_name={this.state.customer_name}
										field_engineer={this.state.field_engineer}
									/>
								</div>
								<div className={classNames({'hidden': this.state.tab !== 'calendar'})}>
									<Collections.MainCalendar
										url={"schedule"}
										formatMapsUrl={this.formatMapsUrl}
										filterEngineer={this.state.filterEngineer}
										updateSchedule={this.updateSchedule}
										getFilterDate={this.state.getFilterDate}
										shouldCalendarReload={this.state.calendarReload}
									/>
								</div>

							</div>
						</div>
					</CardContent>
					<CardActions style={{justifyContent: 'flex-start', padding: '14px'}}>
						<Button id={'save-appointment'} color="primary" onClick={() => {
							this.setState({
								saveTicket: !this.state.saveTicket
							})
						}}>Save</Button>
					</CardActions>
				</Card>

			</div>
		)
	}
};
